import PolicyPage, { PolicySection } from "../../components/policy/PolicyPage";

function PoliticaPrivacidad() {
    return (
        <PolicyPage title="Política de Privacidad">
            <PolicySection title="1. Información que Recopilamos">
                <p>En emmpieza, recopilamos información que usted nos proporciona directamente cuando:</p>
                <ul>
                    <li>Se comunica con nosotros a través de nuestro sitio web</li>
                    <li>Utiliza nuestro chat de cotización</li>
                    <li>Envía formularios de contacto o ideas de proyectos</li>
                    <li>Descarga o utiliza nuestras aplicaciones móviles</li>
                </ul>
                <p>
                    Esta información puede incluir: nombre, correo electrónico, número de teléfono,
                    información sobre su proyecto y cualquier otra información que decida compartir con
                    nosotros.
                </p>
            </PolicySection>

            <PolicySection title="2. Uso de la Información">
                <p>Utilizamos la información recopilada para:</p>
                <ul>
                    <li>Responder a sus consultas y solicitudes</li>
                    <li>Proporcionar cotizaciones y servicios</li>
                    <li>Mejorar nuestros servicios y experiencia del usuario</li>
                    <li>Enviar comunicaciones relacionadas con nuestros servicios</li>
                    <li>Cumplir con obligaciones legales</li>
                </ul>
            </PolicySection>

            <PolicySection title="3. Protección de Datos">
                <p>
                    Implementamos medidas de seguridad técnicas y organizativas para proteger su
                    información personal contra acceso no autorizado, alteración, divulgación o
                    destrucción.
                </p>
            </PolicySection>

            <PolicySection title="4. Compartir Información">
                <p>No vendemos, alquilamos ni compartimos su información personal con terceros, excepto:</p>
                <ul>
                    <li>Cuando sea necesario para proporcionar nuestros servicios</li>
                    <li>Cuando sea requerido por ley</li>
                    <li>Con su consentimiento explícito</li>
                </ul>
            </PolicySection>

            <PolicySection title="5. Sus Derechos">
                <p>Usted tiene derecho a:</p>
                <ul>
                    <li>Acceder a su información personal</li>
                    <li>Rectificar información inexacta</li>
                    <li>Solicitar la eliminación de sus datos</li>
                    <li>Oponerse al procesamiento de sus datos</li>
                    <li>Solicitar la portabilidad de sus datos</li>
                </ul>
            </PolicySection>

            <PolicySection title="6. Cookies y Tecnologías Similares">
                <p>
                    Nuestro sitio web utiliza cookies y tecnologías similares para mejorar su
                    experiencia. Puede configurar su navegador para rechazar cookies, aunque esto puede
                    afectar algunas funcionalidades del sitio.
                </p>
            </PolicySection>

            <PolicySection title="7. Cambios a esta Política">
                <p>
                    Nos reservamos el derecho de actualizar esta política de privacidad en cualquier
                    momento. Le notificaremos sobre cambios significativos publicando la nueva política
                    en esta página.
                </p>
            </PolicySection>

            <PolicySection title="8. Contacto">
                <p>Si tiene preguntas sobre esta política de privacidad, puede contactarnos en:</p>
                <ul>
                    <li>Email: <a href="mailto:emmpieza@gmail.com">emmpieza@gmail.com</a></li>
                    <li>WhatsApp: <a href="https://wa.me/573118569675">+57 311 856 9675</a></li>
                </ul>
            </PolicySection>
        </PolicyPage>
    );
}

export default PoliticaPrivacidad;
